import { createContext } from 'react'
import type { CurrentUser, LoginOutcome, TenantCandidate, TotpOutcome } from './authApi'

export interface AuthContextValue {
  /** `null` — kirilmagan yoki `me` hali yuklanmagan */
  user: CurrentUser | null
  isAuthenticated: boolean
  /** Token bor, lekin `me` hali kelmagan */
  isLoading: boolean
  /** `me` so'rovi xato bergan — token bor, lekin kim ekani noma'lum */
  error: unknown
  /**
   * Login va parol bilan kirishga urinadi.
   *
   * ⚠️ Kirish shu yerda HECH QACHON tugamaydi — TOTP sherik uchun ham
   * MAJBURIY (`PartnerAuthResource` bitta `LoginFlowService` ni
   * ishlatadi). Natija doim ikkitadan biri: TOTP sozlash yoki TOTP kod
   * so'rash. Chaqiruvchi (`LoginPage`) shu bo'yicha `/login/totp` ga
   * yo'naltiradi.
   */
  signIn: (username: string, password: string) => Promise<LoginOutcome>
  /** Birinchi TOTP sozlashda — QR/sirni tasdiqlovchi kod */
  completeTotpSetup: (setupToken: string, code: string) => Promise<TotpOutcome>
  /** Har safargi kirishda — TOTP kod tekshiruvi */
  completeTotpVerify: (totpToken: string, code: string) => Promise<TotpOutcome>
  /** `CHOOSE_TENANT` ekranida karta bosilganda — YAKUNIY qadam */
  completeTenantChoice: (choiceToken: string, tenantId: string) => Promise<void>
  signOut: () => Promise<void>
  /**
   * Huquq tekshiruvi.
   *
   * ⚠️ Bu QULAYLIK, xavfsizlik EMAS: backend har so'rovda qayta
   * tekshiradi (04-ROLES.md §5). Bu yerda yashirishning yagona maqsadi —
   * kassirga bosib bo'lmaydigan tugma ko'rsatmaslik.
   */
  can: (permission: string) => boolean
}

export type { TenantCandidate }

// Providersiz ishlatish — dastur tuzilishidagi xato, shuning uchun
// standart qiymat emas `null` va hook'da aniq xato.
export const AuthContext = createContext<AuthContextValue | null>(null)
